import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('../views/login/Login.vue')},
  { path: '/logout', component: () => import('../views/login/Logout.vue'), meta: { requiresAuth: true }},
  { path: '/', component: () => import('../views/topicList.vue'), meta: { requiresAuth: true }},
  { path: '/group/list/:id', component: () => import('../views/topicList.vue'), meta: { requiresAuth: true }},
  { path: '/add', component: () => import('../views/topicAdd.vue'), meta: { requiresAuth: true }},
  { path: '/update/:id', component: () => import('../views/topicUpdate.vue'), meta: { requiresAuth: true }},
  { path: '/groups', component: () => import('../views/groupList.vue'), meta: { requiresAuth: true }},
  { path: '/group/add', component: () => import('../views/groupAdd.vue'), meta: { requiresAuth: true }},
  { path: '/group/update/:id', component: () => import('../views/groupUpdate.vue'), meta: { requiresAuth: true }},
]

const router = new VueRouter({
  routes,
  mode:'history'
})


/*
    Remember, this will control navegation
*/
router.beforeEach((to, from, next) => {

  const user = localStorage.getItem('user');

  if (to.matched.some(record => record.meta.requiresAuth) && !user) {
    next('/login')
  } else {
    next();
  }
});


export default router
